import { Input } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';
import { addListingDetailsType, ListingDetailsType } from '~addListing/types';

const TotalInstallmentPrice = ({
  listing,
}: {
  listing: ListingDetailsType;
}) => {
  const { t } = useTranslation('app');
  const defaultTotalInstallmentPrice = listing?.payment_plans?.[0]?.price || 0;
  const { mobileScreen } = useBreakpoint();

  const {
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<addListingDetailsType>();

  const handleChange = (value: string) => {
    let paymentPlans = watch('paymentPlans') || [];
    const paymentPlan = paymentPlans[0] || {};
    paymentPlan.price = Number(value.split(',').join('')) ?? 0;
    paymentPlans[0] = paymentPlan;
    setValue('paymentPlans', paymentPlans);
  };

  const paymentPlans = watch('paymentPlans') || [];
  const value = paymentPlans[0]?.price || 0;

  useEffect(() => {
    handleChange(`${defaultTotalInstallmentPrice}`);
  }, [defaultTotalInstallmentPrice]);

  return (
    <Input
      label={{
        component: (
          <p className="text-body-1 text-gray__dark_2 flex gap-x items-center">
            {t('totalInstallmentPrice')}
          </p>
        ),
      }}
      field={{
        type: 'text',
        placeholder: t('totalInstallmentPricePlaceholder'),
        onChange: (e) => handleChange(e.target.value),
        onFocus: () => clearErrors('paymentPlans.0.price'),
        value: value ? value?.toLocaleString() : '',
      }}
      endIcon={
        <p className="border-s ps-x border-gray text-body_2 text-gray__dark_1">
          {mobileScreen ? t('pound') : t('egyptianPound')}
        </p>
      }
      error={
        errors.paymentPlans?.[0]?.price
          ? errors.paymentPlans?.[0]?.price.message ===
            'totalInstallmentPriceMustBeLargeThanPrice'
            ? t('totalInstallmentPriceMustBeLargeThanPrice')
            : t('totalInstallmentPriceRequired')
          : ''
      }
    />
  );
};

export default TotalInstallmentPrice;
